import React from 'react';
export function StickyHeader() {
  return <div className="sticky top-0 z-40 flex min-h-[36px] w-full items-center justify-center bg-gold px-4 py-2 text-center" data-id="element-165" data-mp="2zat6uoerv308">
      <p className="text-[11px] font-semibold leading-snug text-navy sm:text-xs" data-id="element-166" data-mp="1ir7vcknq3lv6">
        <span className="sm:hidden" data-id="element-167" data-mp="1ip5642ue9wri">🌎 Available for instant download worldwide</span>
        <span className="hidden sm:inline" data-id="element-168" data-mp="1dsxz06q9if7z">
          🌎 Available for instant download worldwide · One-Time Payment · Automatic currency
          conversion at checkout
        </span>
      </p>
    </div>;
}